import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: clamp(24px, 5vw, 40px);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;

  @media (max-width: 480px) {
    border-radius: 12px;
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.gray[900]};
  margin-bottom: 32px;
`;

export const SectionTitle = styled.h2`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.primary.main};
  margin: 24px 0 16px;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[100]};
  padding-bottom: 8px;
`;

export const SignUpForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InputGroup = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: ${({ flex }) => flex || 1};
`;

export const Label = styled.label`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray[900]};
  margin-bottom: 8px;
  font-weight: 500;
`;

export const Input = styled.input`
  width: 100%;
  height: 52px;
  padding: 0 16px;
  background: ${({ disabled }) => (disabled ? '#F6F5FC' : '#fff')};
  border: 2px solid ${({ theme }) => theme.colors.gray[100]};
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s ease-in;
  outline: none;
  color: ${({ theme, disabled }) => (disabled ? theme.colors.gray[200] : theme.colors.gray[900])};

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 52px;
  padding: 0 16px;
  background: #fff;
  border: 2px solid ${({ theme }) => theme.colors.gray[100]};
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s ease-in;
  outline: none;
  appearance: none; /* Remove default arrow */
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E");
  background-repeat: no-repeat;
  background-position: right .7em top 50%;
  background-size: .65em auto;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export { Button } from '../shared/Button';

export const RemoveButton = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.danger.main};
  font-size: 14px;
  margin-top: 4px;
  align-self: flex-start;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const Footer = styled.div`
  margin-top: 24px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray[900]};

  button {
    background: none;
    border: none;
    color: ${({ theme }) => theme.colors.primary.main};
    font-weight: bold;
    cursor: pointer;
    margin-left: 4px;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const PasswordInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const TogglePasswordButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.gray[400]};
  transition: color 0.2s ease-in;

  &:hover {
    color: ${({ theme }) => theme.colors.gray[600]};
  }

  &:focus {
    outline: none;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;
